import { HURRICANES_REPLAY_MARKER_MODES } from '../config/hurricanes.config';
import { toLatLng } from './hurricaneGeometry.utils';
import { getLatestObservedStormRecordIndex, isForecastStormRecord } from './hurricanes.utils';

const getVisibleMarkerRecords = (records, activeRecordIndex, cutIndex, markerMode, isReplaying) => {
  const visibleRecords = records
    .slice(0, cutIndex + 1)
    .map((record, recordIndex) => ({ record, recordIndex }));

  if (isReplaying && markerMode === HURRICANES_REPLAY_MARKER_MODES.current) {
    return visibleRecords.filter(({ recordIndex }) => recordIndex === activeRecordIndex);
  }

  return visibleRecords;
};

const buildStormMarker = (stormKey, record, recordIndex, activeRecordIndex) => {
  const position = toLatLng(record.latitude, record.longitude);
  if (!position) return null;

  return {
    key: `${stormKey}-${record.utc_time ?? recordIndex}`,
    position,
    isActive: recordIndex === activeRecordIndex,
    isForecast: isForecastStormRecord(record),
    record,
  };
};

export const getVisibleStormMapItems = (stormShapes = [], frameIndex = null, markerMode) =>
  stormShapes.map(
    ({
      key,
      group,
      observedTrackPositions = [],
      forecastTrackPositions = [],
      conePositions,
      outlinePositions,
    }) => {
      const lastRecordIndex = group.records.length - 1;
      const cutIndex =
        frameIndex === null ? lastRecordIndex : Math.min(frameIndex, lastRecordIndex);
      const activeRecordIndex =
        frameIndex === null ? getLatestObservedStormRecordIndex(group.records) : cutIndex;
      const markerRecords = getVisibleMarkerRecords(
        group.records,
        activeRecordIndex,
        cutIndex,
        markerMode,
        frameIndex !== null,
      );

      return {
        key,
        group,
        isAtTrackEnd: cutIndex >= lastRecordIndex,
        conePositions,
        outlinePositions,
        observedTrackPositions,
        forecastTrackPositions,
        markers: markerRecords
          .map(({ record, recordIndex }) =>
            buildStormMarker(key, record, recordIndex, activeRecordIndex),
          )
          .filter(Boolean),
      };
    },
  );
